<app-lms-modal-frame [title]="'Client Documents'" [pageHeadWidth]="900">
  <div modal-body>
    <div class="container-fluid center-screen">
      <div class="client-header-panel">
        <app-client-header #clientHeaderComponent [clientDetails]="clientShow" [showQuote]="!isReadOnly"></app-client-header>
      </div>
      <div class="card">
        <div class="card-body center-screen my-2">
          <div *ngIf="isDocumentLoading" class="fade show my-1" style="text-align: center; height: 30px">
            <i class="spinner-grow spinner-grow-sm"></i>
            <span class="me-2"> Loading documents, please wait! </span>
          </div>
          <lms-table-wrapper *ngIf="!isDocumentLoading" [config]="config" class="my-3 docs-table-wrap">
            <table class="table p-1 table-striped table-hover table-sm shadow-1-strong rounded-1 client-documents-table">
              <caption>Document List</caption>
              <thead>
                <tr>
                  <th scope="col">Document</th>
                  <th>File name</th>
                  <th scope="col">Upload date</th>
                  <th scope="col">Uploaded by</th>
                  <th scope="col" style="width: 40px;">View</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let doc of lstDocuments | paginate: config">
                  <td>{{doc.documentType}}</td>
                  <td style="text-overflow: ellipsis;">{{doc.originalFileName}}</td>
                  <td>{{covertDate(doc.uploadDate)}}</td>
                  <td>{{doc.userName}}</td>
                  <td style="width: 40px;">
                    <button class="btn btn-floating btn-icon fs-5 fas" mdbRipple (click)="onDownloadPdf(doc)">
                      <i class="fas fa-sm fa-fw fa-eye"></i>
                    </button>
                  </td>
                  <td style="width: 30px;">
                    <span [style.display]="doc.documentType == 'LOAN_SUMMARY_U' && isReadOnly ? 'block': 'none'">
                      <button class="btn btn-floating btn-icon fs-5 fas" color="red" mdbRipple
                        (click)="deleteDocument(doc)">
                        <i class="fas fa-xs fa-trash-can"></i>
                      </button>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </lms-table-wrapper>
        </div>
      </div>
    </div>
  </div>
  <div modal-actions class="flex-container">
    <button type="button" class="btn btn-primary btn-sm" (click)="dialogRef.close()">Close</button>
  </div>
</app-lms-modal-frame>
